var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-referral-footer",attrs:{"role":"footer"}},[_c('div',{staticClass:"plugin-referral-footer__headline"},[_c('plugin-referral-footer-headline')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }